import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom'
import { sessionActionCreators } from '../../stores/lis-session-store';
import { navActionCreators } from '../../stores/lis-nav-store';
import { calendarActionCreators } from '../../stores/lis-calendar-store';
import moment from 'moment-timezone';
import { cancelRequest } from '../../services/request.service';


class PublicCalendarList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            session: '',
            senateIsLoaded: false,
            houseIsLoaded: false,
            senateCalendarList: [],
            houseCalendarList: [],
            showHouseChamber: true,
            showSenateChamber: true,
            selectedChamber: "H"
        };

        this.toggleChamber = this.toggleChamber.bind(this);
    }

    toggleChamber(chamber) {
        this.setState(state => ({
            [chamber]: !state[chamber]
        }));
    }

    //When component has mounted, make the call to get session by code
    componentDidMount() {
        //Update the session selector component, which will run componentDidUpdate and call setupPage on its own
        const sessionCode = this.props.match.params.sessioncode
        if (this.props.nav.session !== sessionCode) {
            this.props.actions.changeSession(sessionCode)
        } else {
            this.setupPage(sessionCode);
        }
    }

    componentDidUpdate(prevProps) {
        // Setup the page if the global selected session changes. Change the URL to reflect the session change
        if (prevProps.nav.session !== this.props.nav.session) {
            this.props.history.push("/session-details/" + this.props.nav.session + "/calendar");
            this.setupPage(this.props.nav.session);
        } else if (this.props.nav.session !== this.props.match.params.sessioncode) {
            // If the url changes then update the global selected session with whatever the url is
            const sessionCode = this.props.match.params.sessioncode;
            if (!isNaN(sessionCode)) {
                this.props.actions.changeSession(sessionCode);
            }
        }
    }

    componentWillUnmount() {
        cancelRequest();
    }

    setupPage(sessionCode) {
        this.setState({
            senateIsLoaded: false,
            houseIsLoaded: false
        });
        //Get the session information
        this.props.actions.getSessionByCode(sessionCode)
            .then(() => {
                if (this.props.session.selectedSession) {
                    this.setState({
                        session: this.props.session.selectedSession
                    });
                }
            });
        //Get the list for the Senate
        this.props.actions.getCalendarList('?sessionCode=' + sessionCode + '&chamberCode=S')
            .then(() => {
                this.setState({
                    senateCalendarList: this.props.calendar.calendarList,
                    senateIsLoaded: true
                });
            });
        //Get the list for the House
        this.props.actions.getCalendarList('?sessionCode=' + sessionCode + '&chamberCode=H')
            .then(() => {
                this.setState({
                    houseCalendarList: this.props.calendar.calendarList,
                    houseIsLoaded: true
                });
            });
    }

    toggleSelectedChamber() {
        this.setState({
            selectedChamber: this.state.selectedChamber === "H" ? "S" : "H"
        })
    }

    render() {
        const { senateCalendarList, houseCalendarList, senateIsLoaded, houseIsLoaded, session } = this.state;
        return (
            <div className="public-chamber-data calendar-list">
                <div>
                    <h2 style={{paddingTop: "5px"}}>Daily Floor Calendars</h2>
                    {window.innerWidth <= 500 &&
                        <div className='toggle-tabs'>
                            <div className={'toggle-tab ' + (this.state.selectedChamber === "H" ? "active" : "")}>
                                <label onClick={() => this.toggleSelectedChamber()}>House</label>
                            </div>
                            <div className={'toggle-tab ' + (this.state.selectedChamber === "S" ? "active" : "")}>
                                <label onClick={() => this.toggleSelectedChamber()}>Senate</label>
                            </div>
                        </div>
                    }
                </div>
                <div className={"public-list " + (window.innerWidth > 500 ? "inner-grid two" : "")}>
                    <div>
                        {window.innerWidth > 500 &&
                            <h3 style={{marginTop: "15px"}}>House</h3>
                        }
                        {(houseIsLoaded && this.state.showHouseChamber && window.innerWidth > 500) || (window.innerWidth <= 500 && this.state.selectedChamber === "H") ?
                            <table className="line-table">
                                <tbody className="toggle-table">
                                        {houseCalendarList.map(calendar =>
                                            <tr key={calendar.CalendarID} className="inner-grid two calendar-row">
                                                <td>
                                                    <Link to={`/session-details/${session.SessionCode}/calendar/${calendar.ReferenceNumber}`}>
                                                        {moment(calendar.CalendarDate).tz('America/New_York').format("dddd, MMMM D, YYYY") + " " + (calendar.CalendarNumber > 1 ? "(sup. " + (calendar.CalendarNumber - 1) + ")" : "")}
                                                    </Link>
                                                </td>
                                            </tr>
                                        )}
                                </tbody>
                            </table>
                            :
                            !houseIsLoaded && <div aria-label="Loading" className="center-spinner spinner"></div>
                        }
                    </div>
                    <div>
                        {window.innerWidth > 500 &&
                            <h3 style={{marginTop: "15px"}}>Senate</h3>
                        }
                        {(senateIsLoaded && this.state.showSenateChamber && window.innerWidth > 500) || (window.innerWidth <= 500 && this.state.selectedChamber === "S") ?
                            <table className="line-table">
                                <tbody className="toggle-table">
                                        {senateCalendarList.map(calendar =>
                                            <tr key={calendar.CalendarID} className="inner-grid two calendar-row">
                                                <td>
                                                    <Link to={`/session-details/${session.SessionCode}/calendar/${calendar.ReferenceNumber}`}>
                                                        {moment(calendar.CalendarDate).tz('America/New_York').format("dddd, MMMM D, YYYY") + " " + (calendar.CalendarNumber > 1 ? "(sup. " + (calendar.CalendarNumber - 1) + ")" : "")}
                                                    </Link>
                                                </td>
                                            </tr>
                                        )}
                                </tbody>
                            </table>
                            :
                            !senateIsLoaded && <div aria-label="Loading" className="center-spinner spinner"></div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    (state) => {
        const { session, nav, calendar } = state;
        return {
            session,
            nav,
            calendar
        }
    },
    (dispatch) => {
        return {
            actions: bindActionCreators(Object.assign({}, sessionActionCreators, navActionCreators, calendarActionCreators), dispatch)
        }
    }
)(PublicCalendarList)
